import React, { useContext } from 'react'
// import PropTypes from "prop-types"
import { createUseStyles } from 'react-jss'
import _ from 'lodash'
// import Button from "../Button";
import SVG from '../SVG/SVG'
import Accordion from '../Accordion'
import PartnerForm from '../PartnerForm'

const ResponsiveContent = ({ content }) => {
  const classes = useStyles()

  return (
    <React.Fragment>
      {!_.isEmpty(content) ? (
        <div className={'responsiveContent'}>
          {content.map((rcC, rcI) =>
            rcC.show_row > 0 ? (
              <div
                key={rcI}
                className={`${classes.rcBack} ${
                  rcC.row_background_color == 'white' ? classes.rcBackWhite : ''
                } ${rcC.row_background_color == 'lightBlue' ? classes.rcBackLightBlue : ''}`}
              >
                {rcC.show_top_divider > 0 ? <hr className={classes.rcDivider} /> : ''}
                <div
                  className={`${classes.rcCon} cols-${rcC.columns.length} ${
                    rcC.mobile_reverse_order ? classes.rcReverse : ''
                  }`}
                >
                  {_.has(rcC, 'columns') && !_.isEmpty(rcC.columns)
                    ? rcC.columns.map((col, colKey) => {
                        return (
                          <div
                            key={colKey}
                            className={`${classes.rcCol} col-${rcC.columns.length}`}
                          >
                            {_.has(col, 'videos') && !_.isEmpty(col.videos) ? (
                              <div className={classes.rcVideoPopup}>
                                {col.videos.map((vid, vidKey) =>
                                  !_.isEmpty(vid.youtube_id) ||
                                  (!_.isEmpty(vid.vimeo_link) && !_.isEmpty(vid.vimeo_image)) ? (
                                    <div key={vidKey} className={classes.rcVideoPopupCon}>
                                      {vid.vid_title_display > 0 ? (
                                        <div className={classes.rcVideoPopupTitle}>
                                          {vid.vid_title}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      <div className={classes.rcVideoPopupLinkCon}>
                                        {!_.isEmpty(vid.youtube_id) && vid.vid_type == 'youtube' ? (
                                          <a
                                            className={classes.rcVideoPopupLink}
                                            href={`https://youtu.be/${vid.youtube_id}&rel=0`}
                                            data-lity
                                          >
                                            <img
                                              className={classes.rcVideoPopupImage}
                                              src={`https://img.youtube.com/vi/${vid.youtube_id}/0.jpg`}
                                              alt={`iFrame ${
                                                vid.vid_view == 'rotate' ? '360' : ''
                                              } Video`}
                                            />
                                          </a>
                                        ) : (
                                          ''
                                        )}
                                        {!_.isEmpty(vid.vimeo_link) &&
                                        !_.isEmpty(vid.vimeo_image) &&
                                        vid.vid_type == 'vimeo' ? (
                                          <a
                                            className={classes.rcVideoPopupLink}
                                            href={vid.vimeo_link}
                                            data-lity
                                          >
                                            <img
                                              className={classes.rcVideoPopupImage}
                                              src={vid.vimeo_image}
                                              alt={`iFrame ${
                                                vid.vid_view == 'rotate' ? '360' : ''
                                              } Video`}
                                            />
                                          </a>
                                        ) : (
                                          ''
                                        )}
                                        <div className={`${classes.rcVideoPopupPlay} play`}>
                                          {vid.vid_view == 'play' ? (
                                            <SVG name={'Play'} colorOne={'#f6c414'} />
                                          ) : (
                                            ''
                                          )}
                                          {vid.vid_view == 'rotate' ? (
                                            <SVG name={'Rotate'} colorOne={'#f6c414'} />
                                          ) : (
                                            ''
                                          )}
                                          {vid.vid_view == 'view' ? (
                                            <SVG name={'Search'} colorOne={'#f6c414'} />
                                          ) : (
                                            ''
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  ),
                                )}
                              </div>
                            ) : null}

                            {_.has(col, 'content_block') && !_.isEmpty(col.content_block) ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: col.content_block,
                                }}
                              />
                            ) : null}

                            {_.has(col, 'buttons') && !_.isEmpty(col.buttons) ? (
                              <div className={classes.rcBtnCon}>
                                {col.buttons.map((btn, btnKey) =>
                                  !_.isEmpty(btn.btn_text) && !_.isEmpty(btn.btn_link) ? (
                                    btn.lightbox > 0 ? (
                                      <a
                                        key={btnKey}
                                        data-lity={''}
                                        data-lity-description={btn.lightbox_description}
                                        className={`${
                                          btn.btn_style == 'btnYellow'
                                            ? classes.rcBtnYellow
                                            : classes.rcBtnBlue
                                        }`}
                                        href={btn.btn_link}
                                      >
                                        {btn.btn_text}
                                      </a>
                                    ) : (
                                      <a
                                        key={btnKey}
                                        className={`${
                                          btn.btn_style == 'btnYellow'
                                            ? classes.rcBtnYellow
                                            : classes.rcBtnBlue
                                        }`}
                                        href={btn.btn_link}
                                      >
                                        {btn.btn_text}
                                      </a>
                                    )
                                  ) : (
                                    ''
                                  ),
                                )}
                              </div>
                            ) : null}

                            {_.has(col, 'zaccordion') && !_.isEmpty(col.zaccordion) ? (
                              <div
                                style={{
                                  width: '100%',
                                  maxWidth: '961px',
                                  margin: '0 auto',
                                  padding: '20px',
                                }}
                              >
                                {col.zaccordion.map((row, i) => (
                                  <Accordion key={`Accordion${i}`} title={row.title}>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: row.body,
                                      }}
                                    ></div>
                                  </Accordion>
                                ))}
                              </div>
                            ) : null}

                            {_.has(col, 'partnerRegister') && !_.isEmpty(col.partnerRegister) ? (
                              <div
                                style={{
                                  width: '100%',
                                  maxWidth: '961px',
                                  margin: '0 auto',
                                  padding: '20px',
                                }}
                              >
                                {col.partnerRegister.map((row, i) => (
                                  <div key={`Accordion${i}`}>
                                    <PartnerForm {...row} />
                                  </div>
                                ))}
                              </div>
                            ) : null}
                          </div>
                        )
                      })
                    : null}
                </div>
                {rcC.show_bottom_divider > 0 ? <hr className={classes.rcDivider} /> : null}
              </div>
            ) : null,
          )}
        </div>
      ) : null}
    </React.Fragment>
  )
}

const useStyles = createUseStyles(theme => ({
  rcBack: {
    width: '100%',
  },

  rcBackWhite: {
    backgroundColor: theme.colors.white,
  },

  rcBackLightBlue: {
    backgroundColor: theme.colors.lightestblue,
  },

  rcCon: {
    margin: '0 auto',
    padding: '10px 25px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: 1250,

    '&.cols-3': {
      '@media (max-width: 900px)': {
        flexWrap: 'wrap',
      },
    },

    '&.cols-4': {
      '@media (max-width: 900px)': {
        flexWrap: 'wrap',
      },
    },

    '@media (max-width: 679px)': {
      flexWrap: 'unset',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },

  rcReverse: {
    '@media (max-width: 679px)': {
      flexDirection: 'column-reverse',
    },
  },

  rcHeading: {
    margin: '0 0 20px',
    padding: '10px 0',
    color: theme.colors.blue,
    fontFamily: theme.fontFamily,
    fontWeight: 500,
    fontSize: 40,
    letterSpacing: 0.6,
    lineHeight: 1.5,
    wordSpacing: 1.8,
  },

  rcDivider: {
    border: 0,
    height: 1,
    backgroundImage: 'linear-gradient(to left, #f0f0f0, #8c8b8b, #f0f0f0)',
    width: 'calc(100% - 110px)',
    margin: '30px auto',
    maxWidth: 'calc(1250px - 110px)',
  },

  rcCol: {
    flexBasis: '100%',
    boxSizing: 'border-box',
    padding: '0 10px',
    position: 'relative',

    '& h1': {
      margin: '0 0 20px',
      padding: '10px 0',
      color: theme.colors.blue,
      fontFamily: theme.fontFamily,
      fontWeight: 900,
      fontSize: 40,
      letterSpacing: 0.6,
      lineHeight: 1.5,
      wordSpacing: 1.8,
    },

    '& h2': {
      margin: '0 0 20px',
      padding: '10px 0',
      color: theme.colors.ocean,
      fontFamily: theme.fontFamily,
      fontWeight: 900,
      fontSize: 34,
      letterSpacing: 1.5,
      lineHeight: 1.5,
      wordSpacing: 1.5,
      textTransform: 'uppercase',
    },

    '& h3': {
      margin: '0 0 20px',
      padding: '10px 0',
      color: theme.colors.darkergrey,
      fontFamily: theme.fontFamily,
      fontWeight: 500,
      fontSize: 28,
      letterSpacing: 0.4,
      lineHeight: 1.4,
      wordSpacing: 1.3,
    },

    '& h4': {
      margin: '0 0 20px',
      padding: '10px 0',
      color: theme.colors.darkergrey,
      fontFamily: theme.fontFamily,
      fontWeight: 500,
      fontSize: 24,
      letterSpacing: 0.3,
      lineHeight: 1.4,
      wordSpacing: 1.1,
    },

    '& h5': {
      margin: '0 0 20px',
      padding: '10px 0',
      // color: theme.colors.darkgrey,
      color: theme.colors.warmGrey,
      fontFamily: theme.fontFamily,
      fontWeight: 500,
      fontSize: 24,
      letterSpacing: 0.3,
      lineHeight: 1.4,
      wordSpacing: 1.1,
    },

    '& h6': {
      margin: '0 0 20px',
      padding: '10px 0',
      // color: theme.colors.darkgrey,
      color: theme.colors.warmGrey,
      fontFamily: theme.fontFamily,
      fontWeight: 500,
      fontSize: 18,
      letterSpacing: 0.3,
      lineHeight: 1.4,
      wordSpacing: 1.1,
    },

    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },

    '& p': {
      fontSize: 16,
      // color: theme.colors.darkgrey,
      // color: theme.colors.warmGrey,
      color: theme.colors.brushedsteel,
      fontFamily: theme.fontFamily,
      fontWeight: 400,
    },

    '& ul': {
      margin: 0,
      fontSize: 16,
      // color: theme.colors.darkgrey,
      // color: theme.colors.warmGrey,
      color: theme.colors.brushedsteel,
      fontFamily: theme.fontFamily,
      fontWeight: 400,
      listStyleImage: `url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjEzIiBzdHlsZT0iIj48cmVjdCBpZD0iYmFja2dyb3VuZHJlY3QiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHg9IjAiIHk9IjAiIGZpbGw9Im5vbmUiIHN0cm9rZT0ibm9uZSIvPjxnIGNsYXNzPSJjdXJyZW50TGF5ZXIiIHN0eWxlPSIiPjx0aXRsZT5MYXllciAxPC90aXRsZT48cGF0aCBkPSJNLjAyNCAxMS42NTVMLjg1NiAxMyA4IDYuNzguODggMCAwIDEuM2w1LjY5IDUuNDIiIGlkPSJzdmdfMSIgY2xhc3M9InNlbGVjdGVkIiBmaWxsPSIjMDAzODZjIiBmaWxsLW9wYWNpdHk9IjEiLz48L2c+PC9zdmc+")`,

      '& li': {
        margin: 0,
        fontSize: 16,
        // color: theme.colors.darkgrey,
        // color: theme.colors.warmGrey,
        color: theme.colors.brushedsteel,
        fontFamily: theme.fontFamily,
        fontWeight: 400,
        padding: 5,
      },

      '& li ul': {
        listStyleImage: `url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjEzIiBzdHlsZT0iIj48cmVjdCBpZD0iYmFja2dyb3VuZHJlY3QiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHg9IjAiIHk9IjAiIGZpbGw9Im5vbmUiIHN0cm9rZT0ibm9uZSIvPjxnIGNsYXNzPSJjdXJyZW50TGF5ZXIiIHN0eWxlPSIiPjx0aXRsZT5MYXllciAxPC90aXRsZT48cGF0aCBkPSJNLjAyNCAxMS42NTVMLjg1NiAxMyA4IDYuNzguODggMCAwIDEuM2w1LjY5IDUuNDIiIGlkPSJzdmdfMSIgY2xhc3M9InNlbGVjdGVkIiBmaWxsPSIjMDA1NmE3IiBmaWxsLW9wYWNpdHk9IjEiLz48L2c+PC9zdmc+")`,

        '& li ul': {
          listStyleImage: `url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjEzIiBzdHlsZT0iIj48cmVjdCBpZD0iYmFja2dyb3VuZHJlY3QiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHg9IjAiIHk9IjAiIGZpbGw9Im5vbmUiIHN0cm9rZT0ibm9uZSIvPjxnIGNsYXNzPSJjdXJyZW50TGF5ZXIiIHN0eWxlPSIiPjx0aXRsZT5MYXllciAxPC90aXRsZT48cGF0aCBkPSJNLjAyNCAxMS42NTVMLjg1NiAxMyA4IDYuNzguODggMCAwIDEuM2w1LjY5IDUuNDIiIGlkPSJzdmdfMSIgY2xhc3M9InNlbGVjdGVkIiBmaWxsPSIjMDA1NmE3IiBmaWxsLW9wYWNpdHk9IjEiLz48L2c+PC9zdmc+")`,
        },
      },
    },

    '& ol': {
      margin: 0,
      fontSize: 16,
      // color: theme.colors.darkgrey,
      // color: theme.colors.warmGrey,
      color: theme.colors.brushedsteel,
      fontFamily: theme.fontFamily,
      fontWeight: 400,
      listStyle: 'none',
      counterReset: 'li',

      '& li': {
        margin: 0,
        fontSize: 16,
        // color: theme.colors.darkgrey,
        // color: theme.colors.warmGrey,
        color: theme.colors.brushedsteel,
        fontFamily: theme.fontFamily,
        fontWeight: 400,
        padding: 5,
        counterIncrement: 'li',

        '&:before': {
          content: "'.'counter(li)",
          color: theme.colors.blue,
          display: 'inline-block',
          width: 1,
          marginLeft: -1.5,
          marginRight: 0.5,
          textAlign: 'right',
          direction: 'rtl',
          fontWeight: 500,
        },
      },
    },

    '& dl': {
      margin: 0,
      fontSize: 16,
      // color: theme.colors.darkgrey,
      // color: theme.colors.warmGrey,
      color: theme.colors.brushedsteel,
      fontFamily: theme.fontFamily,
      fontWeight: 400,

      '& dt': {
        margin: 0,
        fontSize: 16,
        fontWeight: 400,
        padding: 5,
        color: theme.colors.blue,
      },

      '& dd': {
        margin: 0,
        fontSize: 16,
        fontWeight: 400,
        // color: theme.colors.darkgrey,
        // color: theme.colors.warmGrey,
        color: theme.colors.brushedsteel,
        padding: 5,
      },
    },

    '& a': {
      fontSize: 16,
      color: theme.colors.blue,
      fontFamily: theme.fontFamily,
      fontWeight: 400,
      fontStyle: 'italic',
      letterSpacing: 0.2,
      textDecoration: 'underline',

      '&:hover': {
        color: theme.colors.lightblue,
        textDecoration: 'underline',
      },
    },

    '& hr': {
      border: 0,
      height: 1,
      backgroundImage: 'linear-gradient(to left, #f0f0f0, #8c8b8b, #f0f0f0)',
      width: 'calc(100% - 110px)',
      margin: '30px auto',
      maxWidth: 'calc(1250px - 110px)',
    },

    '& blockquote': {
      position: 'relative',
      paddingLeft: 20,
      borderLeft: '5px solid ' + theme.colors.blue,
      fontFamily: theme.fontFamily,
      fontSize: 22,
      lineHeight: 1.5,
      fontWeight: 100,
      margin: '30px 0',
      '&:before, &:after': {
        content: "'\\201C'",
        fontFamily: "'Roboto, Lato, Open Sans'",
        color: theme.colors.blue,
      },
      '&:after': {
        content: "'\\201D'",
      },
    },

    '&:first-child': {
      paddingLeft: 0,
    },

    '&:last-child': {
      paddingRight: 0,
    },

    '&.col-3': {
      '@media (max-width: 900px)': {
        flex: '1 0 50%',

        '&:nth-child(2)': {
          padding: '0 0 0 10px',
        },
        '&:nth-child(3)': {
          padding: 0,
        },
      },
      '@media (max-width: 679px)': {
        flex: '1 0 auto',

        '&:nth-child(2)': {
          padding: 0,
        },
      },
    },

    '&.col-4': {
      '@media (max-width: 900px)': {
        flex: '0 0 50%',

        '&:nth-child(2)': {
          padding: '0 0 0 10px',
        },
        '&:nth-child(3)': {
          padding: '0 10px 0 0',
        },
      },
      '@media (max-width: 679px)': {
        flex: '1 0 auto',

        '&:nth-child(2)': {
          padding: 0,
        },
        '&:nth-child(3)': {
          padding: 0,
        },
      },
    },

    '@media (max-width: 679px)': {
      padding: 0,
      flex: '1 0 auto',
    },
  },

  rcBtnCon: {
    margin: '10px auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'space-around',

    '@media (max-width: 679px)': {
      flexDirection: 'column',
    },
  },

  rcBtnYellow: {
    backgroundColor: theme.colors.yellow,
    borderRadius: theme.borderRadius,
    borderStyle: 'none',
    borderWidth: 'none',
    cursor: 'pointer',
    fontSize: '14px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    letterSpacing: '1.2px !important',
    lineHeight: '16px',
    padding: '12px 38px',
    textAlign: 'center',
    textDecoration: 'none !Important',
    textTransform: 'uppercase',
    transition: `background-color ${theme.animations.animate}, color ${theme.animations.animate}`,
    color: theme.colors.blue,
    margin: 10,

    '@media (max-width: 679px)': {
      margin: '10px auto',
      width: 200,
    },

    '&:hover': {
      backgroundColor: theme.colors.sunflower,
      textDecoration: 'none !Important',
    },
  },

  rcBtnBlue: {
    backgroundColor: theme.colors.blue,
    borderRadius: theme.borderRadius,
    borderStyle: 'none',
    borderWidth: 'none',
    cursor: 'pointer',
    fontSize: '14px !important',
    fontWeight: 'bold !important',
    fontStyle: 'normal !important',
    letterSpacing: '1.2px !important',
    lineHeight: '16px',
    padding: '12px 38px',
    textAlign: 'center',
    textDecoration: 'none !Important',
    textTransform: 'uppercase',
    transition: `background-color ${theme.animations.animate}, color ${theme.animations.animate}`,
    color: `${theme.colors.white} !Important`,
    margin: 10,

    '@media (max-width: 679px)': {
      margin: '10px auto',
      width: 200,
    },

    '&:hover': {
      backgroundColor: theme.colors.lightblue,
      textDecoration: 'none !Important',
    },
  },

  rcVideoPopup: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: 30,
    maxWidth: 1150,
    margin: '0 auto',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },

  rcVideoPopupCon: {
    margin: '0 auto',
    width: 320,
    boxSizing: 'border-box',
    padding: 20,
    display: 'flex',
    flexDirection: 'column',

    '@media (max-width: 679px)': {
      width: '100%',
      maxWidth: 320,
    },
  },

  rcVideoPopupLink: {
    color: theme.colors.darkergrey,

    '&:hover img': {
      transform: 'scale(1.048)',
    },

    '&:hover ~ .play': {
      opacity: 1,
    },
  },

  rcVideoPopupLinkCon: {
    position: 'relative',
    minWidth: 250,
    minHeight: 150,
    textAlign: 'center',
  },

  rcVideoPopupTitle: {
    textAlign: 'center',
    padding: '5px 0',
    marginBottom: 15,
    fontSize: 16,
    fontWeight: 500,
    color: theme.colors.darkergrey,
  },

  rcVideoPopupImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    margin: 'auto',
    transition: 'all 500ms',
  },

  rcVideoPopupPlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    width: 'max-content',
    height: 'max-content',
    pointerEvents: 'none',
    opacity: 0.7,
    transition: 'all 500ms',
    filter: 'drop-shadow(-5px -3px 7px #000)',

    '& svg': {
      fill: theme.colors.yellow,
      width: 100,
      height: 'auto',

      '& g': {
        fill: theme.colors.yellow,
      },

      '& path': {
        fill: theme.colors.yellow,
      },
    },
  },
}))

export default ResponsiveContent
